module.exports = __webpack_public_path__ + "img/thumb8.2bef5703.png";